import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { cn } from '@/utils/cn';
import { BrandIdentity } from './components/BrandIdentity';
import GeneralInformation from './components/GeneralInformation';
import Links from './components/Links';
import PaymentBlock from './components/PaymentBlock';
import Support from './components/Support';

interface Props {
  className?: string;
}

const Footer = ({ className }: Props) => {
  const t = useTranslations('footer');
  const [isLinksAccordionOpen, setIsLinksAccordionOpen] = useState(false);

  return (
    <div className={cn('w-full bg-c1000 z-3 lg:pt-3 pb-7 lg:pb-7', className)}>
      <div className="global-container 3xl:max-w-412 bg-transparent! py-0">
        <PaymentBlock />
      </div>
      <div className="h-px bg-main-800/60 mt-4 mb-2.5 lg:mt-2.75 lg:mb-7 3xl:mb-7" />
      <div className="global-container 3xl:max-w-412 3xl:flex 3xl:gap-26.5 bg-transparent! py-0">
        <BrandIdentity className="3xl:flex hidden" />
        <div className="flex flex-col">
          <div className="flex flex-col xl:flex-row justify-between">
            <div className="flex xl:gap-21.5 xl:justify-between justify-center w-full">
              <BrandIdentity className="3xl:hidden" />
              <div className="hidden xl:flex flex-col w-full">
                <div className="flex items-start gap-23.5 xl:gap-0 xl:mt-1.25 3xl:mt-0 3xl:gap-16.5">
                  <Links className="3xl:w-full" />
                  <Support className="ml-auto 3xl:ml-0 3xl:mt-0 3xl:mr-1.5" />
                </div>
              </div>
            </div>
            <div className="flex flex-col xl:hidden w-full">
              <Links onAccordionChange={setIsLinksAccordionOpen} />
              <GeneralInformation isAccordionOpen={isLinksAccordionOpen} />
            </div>
          </div>
          <div className="hidden xl:flex flex-col w-full">
            <GeneralInformation />
            <p className="text-c600/50 paragraph-xs-medium mt-4">
              {t('copyright')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
